import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './ChatSlice';
export const adminApi = createApi({
  reducerPath: 'adminApi', // Key to store API cache in the Redux state
  baseQuery: fetchBaseQuery(),// baseQueryWithReauth, //fetchBaseQuery({ baseUrl: '/api/email'}), // Replace with your backend URL
  endpoints: (builder) => ({
    messageAgent: builder.mutation<any, any>({
      query: (body: any) => {      
        const ret = ({
          url: `/api/agents/messageAgent`, //backend endpoint
          method: `POST`, 
          body: body
        })
        return ret
      }
    }),
     inAppMessageAgent: builder.mutation<any, any>({
      query: (body: any) => {      
        const ret = ({
          url: `/api/agents/inAppMessageAgent`, //backend endpoint
          method: `POST`, 
          body: body
        })
        return ret
      }
    }),
  }),
});

// Export hooks generated by createApi
//export const { useSendNewsletterMutation, useSendUnreadMessageEmailsQuery} = emailApiSlice;

export const { useMessageAgentMutation, useInAppMessageAgentMutation} = adminApi;
